"use client";

import type { ReactNode } from "react";
import { NextIntlClientProvider } from "next-intl";
import type { AbstractIntlMessages } from "next-intl";
import { ThemeProvider } from "@/components/theme-provider";

interface ProvidersProps {
  locale: string;
  // AbstractIntlMessages is the correct type for next-intl message objects;
  // using it here avoids a type mismatch with the value returned by getMessages().
  messages: AbstractIntlMessages;
  children: ReactNode;
}

/**
 * Client-side provider tree.
 *
 * NextIntlClientProvider must live in a client boundary so the i18n
 * context is established during client hydration. ThemeProvider is
 * nested here too since both are client-only context providers.
 */
export function Providers({ locale, messages, children }: ProvidersProps) {
  return (
    <NextIntlClientProvider locale={locale} messages={messages}>
      <ThemeProvider
        attribute="class"
        defaultTheme="dark"
        enableSystem
        disableTransitionOnChange
      >
        {children}
      </ThemeProvider>
    </NextIntlClientProvider>
  );
}
